// Finds the moments people need to look at in a recorded race, so ?moment= can seek straight to them. Pure.
import { decode } from '../signal/decode';
import { parseTsv } from '../signal/sources/tsv';
import type { Moment } from './params';

/** Recording times (ms) of each moment's first occurrence; null when the recording lacks it. */
export type Moments = Record<Moment, number | null>;

/** How long before each moment the replay starts, so the scene is settled when it happens. */
export const LEAD_IN_MS: Record<Moment, number> = { gates: 4000, ham: 1500, catnip: 1500, podium: 0 };

export function findMoments(tsv: string): Moments {
  const m: Moments = { gates: null, ham: null, catnip: null, podium: null };
  let prev: string | null = null;
  for (const line of parseTsv(tsv)) {
    const f = decode(line.b64);
    if (!f) continue;
    // Post time: the first running frame after a starting one. The cats are in the gates just before it.
    if (m.gates === null && f.state === 'running' && prev === 'starting') m.gates = line.ms;
    if (m.gates !== null && f.state === 'running') {
      if (m.ham === null && f.cats?.some((c) => c.ham)) m.ham = line.ms;
      if (m.catnip === null && f.cats?.some((c) => c.nip)) m.catnip = line.ms;
    }
    if (m.gates !== null && m.podium === null && f.state === 'finished') m.podium = line.ms;
    prev = f.state;
  }
  return m;
}

/** Replay seek (ms) for a moment, or null when the recording does not hold it. */
export function momentSeekMs(moment: Moment, moments: Moments): number | null {
  const at = moments[moment];
  return at === null ? null : Math.max(0, at - LEAD_IN_MS[moment]);
}
